import { Outlet } from "react-router-dom";

import { Processes } from "@src/components/MainApp/Alerts/Processes";
import { NavigationDrawer } from "@src/components/Navigation/BaseSideNav/NavigationDrawer";

import { AppLayoutShell } from "./layout/AppLayoutShell";

export const OnboardingPageProvider = () => (
  <AppLayoutShell
    sideNav={<NavigationDrawer isUnauthorized={false} />}
    maxWidth="none"
  >
    <Processes />
    <Outlet />
  </AppLayoutShell>
);
